import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ConfigServiceProvider} from '../../../core/services/config-service/config-service';
import {StorageServiceProvider} from '../../../core/services/storage-service/storage-service';

/*
  Generated class for the PrizesServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class PrizesServiceProvider {

  constructor(public http: HttpClient, private configService: ConfigServiceProvider,
              private storageService: StorageServiceProvider) {
  }

  load(){
    return new Promise((resolve, reject) => {
      Promise.all([
        this.http.get(this.configService.getUrl('prizes')).toPromise(),
        this.http.get(this.configService.getUrl('prizeClaims')).toPromise()
      ]).then((response:any) => {
        let [prizes, prizeClaims] = response;
        Promise.all([
          this.storageService.setObject('prizes', prizes),
          this.savePrizeClaims(prizeClaims)
        ]).then(()=>{
          resolve();
        }).catch((err)=>{
          reject(err);
        });
      }).catch((err) => {
        reject(err);
      })
    });
  }
  getPrizes() {
    return this.storageService.getObject('prizes');
  }
  getPrizeClaims() {
    return this.storageService.getObject('prizeClaims');
  }
  getPrize(id) {
    return new Promise((resolve, reject) => {
      this.storageService.getObject('prizes').then((prizes:any[]) => {
        for (let i = 0; i < prizes.length; i++) {
          if (prizes[i].id * 1 === id * 1) {
            resolve(prizes[i]);
          }
        }
        reject('object_not_found');
      }).catch((err) => {
        reject(err);
      });
    });
  }
  savePrizeClaims(prizeClaims){
    this.storageService.setObject('prizeClaims', prizeClaims);
  }
  savePrizes(prize){
    this.storageService.getObject('prizes').then(function (prizes:any[]) {
      if (prizes) {
        for (let i = 0; i < prizes.length; i++) {
          if (prizes[i].id === prize.id) {
            prizes[i] = prize;
            this.storageService.setObject('prizes', prizes);
          }
        }
      }
    })
  }
  choosePrize(prizeId, prizeClaimId){
    return new Promise((resolve, reject) => {
      this.http.get(this.configService.getUrl('prizeClaims') + '/' + prizeClaimId + '/' + 'choose' + '/' + prizeId  + '/prize')
        .toPromise()
        .then((response) => {
          resolve(response);
        }).catch((err) => {
          reject(err);
        })
    });
  }
};



// WEBPACK FOOTER //
// ./src/modules/prizes/services/prizes-service/prizes-service.ts